import React from "react";
import Card from "../../components/Card/Card";
import GridItem from "../../components/Grid/GridItem";
import GridContainer from "../../components/Grid/GridContainer";
import LinearProgress from '@material-ui/core/LinearProgress';
// import LinearProgressWithLabel from '@material-ui/core/LinearProgressWithLabel';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CustomLinearProgress from "../../components/CustomLinearProgress/CustomLinearProgress";
import AccountSeriesProgress from "./AccountSeriesProgress";
import CardBody from "../../components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import Avatar from '@material-ui/core/Avatar';

import CardAvatar from "../../components/Card/CardAvatar";
import intl from "react-intl-universal";


class AccountSeriesItem extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			progressColor: 'info',
			opacity: 1,
			seriesActive: intl.get('exchange'),
			seriesUseStatus: intl.get('exchange'),
			color: '#2c5364',
			colorName: 'rose',
			showMenu: intl.get('go_sub'),
			showMenuNewPage: '/plans',

			avatarPadding: '0px',
		};


		if (this.props.data.seriesTitle === intl.get('free_video')) {
			this.state.avatarPadding = '4px'
		}

		if (this.props.data.useHave) {
			const per = Math.round(this.props.data.seriesDone / this.props.data.seriesAll * 100);
			if (per === 100) {
				this.state.color = '#4caf50';
				this.state.colorName = 'success';
				this.state.seriesUseStatus = intl.get('finish');
				this.state.showMenu = intl.get('go_view');
			} else if (per >= 60) {
				this.state.color = '#ff9800';
				this.state.colorName = 'warning';
				this.state.seriesUseStatus = intl.get('in_study');
				this.state.showMenu = intl.get('continue_study');
			} else if (per > 0) {
				this.state.color = '#f44336';
				this.state.colorName = 'danger';
				this.state.seriesUseStatus = intl.get('in_study');
				this.state.showMenu = intl.get('continue_study');
			} else {
				this.state.color = '#2c5364';
				this.state.colorName = 'primary';
				this.state.seriesUseStatus = intl.get('not_start');
				this.state.showMenu = intl.get('start_study');
			}


			const currentTime = new Date().getTime();

			const diffTimeHour = (currentTime - parseInt(this.props.data.seriesLastActive)) / 1000 / 60 / 60;
			if (diffTimeHour === 0) {
				this.state.seriesActive = intl.get('exchange');
			} else {

				if (diffTimeHour <= 1) {
					this.state.seriesActive = intl.get('just');
				} else if (diffTimeHour <= 24) {
					this.state.seriesActive = intl.get('today');
				} else if (diffTimeHour <= 24 * 7) {
					this.state.seriesActive = intl.get('weekly');
				} else if (diffTimeHour <= 24 * 31) {
					this.state.seriesActive = intl.get('month');
				} else if (diffTimeHour <= 24 * 31 * 6) {
					this.state.seriesActive = intl.get('in_half_year');
				} else {
					this.state.seriesActive = intl.get('out_half_year');
				}

			}
			this.state.showMenuNewPage = '/series_info/' + this.props.data.seriesId;
		} else {
			this.state.opacity = 0.6
		}
	}


	render() {

		return (
			<Card style={{
				// backgroundColor: '#f3f5f3',
				opacity: `${this.state.opacity}`,
				margin: '0px', marginTop: '12px'
			}}
				  color={"default"}
			>
				<CardBody>
					<GridContainer alignItems="center">
						<GridItem xs={3} sm={3} md={1}>
							<Avatar src={this.props.data.seriesImage}
									style={{padding: `${this.state.avatarPadding}`}}/>
						</GridItem>

						<GridItem xs={9} sm={9} md={2}>
							<h5>
								<b>
									{this.props.data.seriesTitle}
								</b>
							</h5>
							<h6 style={{
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							}}>
								{this.props.data.seriesInfo.substring(0, 10)}...
							</h6>
						</GridItem>
						<GridItem xs={12} sm={12} md={3}>
							<AccountSeriesProgress
								all={this.props.data.seriesAll}
								done={this.props.data.seriesDone}
							/>
						</GridItem>

						<GridItem xs={4} sm={4} md={2}>
							{this.state.seriesActive}
						</GridItem>
						<GridItem xs={4} sm={4} md={2}>
							<span style={{color: `${this.state.color}`}}>
							{this.state.seriesUseStatus}
							</span>
						</GridItem>
						<GridItem xs={4} sm={4} md={2}>
							<Button color={this.state.colorName}
									href={this.state.showMenuNewPage}>
								{this.state.showMenu}
							</Button>
						</GridItem>
					</GridContainer>
				</CardBody>
			</Card>
		);
	}
}

export default AccountSeriesItem